export enum ImportTypeEnum {
  DEVICE = 'device',
  USER = 'user',
  TECHNOLOGY = 'technology',
  LICENCE = 'licence',
}